import type {ReactAction} from '@netx/core/bootstrap';
import {faShare} from '@fortawesome/pro-solid-svg-icons';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {assetActionShareLink} from './asset-share-link';
import {assetActionShareEmbedLink} from './asset-share-embed-link';
import {assetActionSharePublishBrightcove} from './asset-share-publish-brightcove';
import {assetActionSharePublishYoutube} from './asset-share-publish-youtube';

export const assetActionShareMenuIcon = faShare;

/**
 * Share asset
 * @param params
 * @returns Action
 */
export const assetActionShareMenu = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-share-menu',
	cb: () => {},
	icon: assetActionShareMenuIcon,
	children: [
		assetActionShareLink(asset),
		assetActionShareEmbedLink(asset),

		assetActionSharePublishBrightcove(asset, {
			group: 2,
		}),
		assetActionSharePublishYoutube(asset, {
			group: 2,
		}),
	],
	get label() {
		return AssetActionLabel.MENU;
	},
	...params,
});

export default assetActionShareMenu;
